import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { DateTime } from 'luxon';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { AppValidators } from 'src/app/common/appValidators';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { IssuesFiltersModel } from 'src/app/models/filters/implementations/pageFilters/issuesFilters.model';
import { ISelectOption } from 'src/app/models/selectOptions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-issues-filters',
  templateUrl: './issues-filters.component.html',
  styleUrls: ['./issues-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssuesFiltersComponent implements OnInit {
  @Input() public pageFilters: IssuesFiltersModel;

  public clearCustomViewSelection$ = new BehaviorSubject(undefined);

  public selectedOptions: ISelectOption[] = [];

  public searchBoxNewValue = new ReplaySubject<string | undefined>(1);
  public firstSeenFromDateNewValue = new ReplaySubject<Date | undefined>(1);
  public firstSeenToDateNewValue = new ReplaySubject<Date | undefined>(1);
  public searchValidators = [AppValidators.evenNumberOfQuoteMarks];
  public minDate = DateTime.now().minus({ months: 3 }).toJSDate();

  private _customViewTriggered = false;

  private readonly _cdr = inject(ChangeDetectorRef);

  constructor(private readonly _destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.pageFilters.onUpdate$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((data) => {
      this.selectedOptions = this.pageFilters.getAllSelectedOptions();

      this.searchBoxNewValue.next(data.search);
      this.firstSeenFromDateNewValue.next(data.firstSeenFromDate);
      this.firstSeenToDateNewValue.next(data.firstSeenToDate);

      if (this._customViewTriggered) {
        this._customViewTriggered = false;
      } else {
        this.clearCustomViewSelection$.next(undefined);
      }

      this._cdr.markForCheck();
    });
  }

  public firstSeenFromDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.FirstSeenFromDate, value);
  }

  public firstSeenToDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.FirstSeenToDate, value);
  }

  public searchSubmitted(value?: string): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.Search, value);
  }
}
